module.exports = __webpack_public_path__ + "img/strip-21.5b0404ae.jpg";